import { useCheckMemberSupplier } from 'hooks';
import { useCheckSharedOnlyMyCompany } from 'hooks/useCheckPrivateMember';
import { useGetMemberInfo } from 'hooks/useGetMemberInfo';

import { useUserInfo } from 'hooks/auth/useUserInfo';

const useCheckAssignProductToSupplier = () => {
  const isMemberSupplierUser = useCheckMemberSupplier();
  const isSharedOnlyMember = useCheckSharedOnlyMyCompany();

  let { userInfo } = useUserInfo();

  const { memberInfo } = useGetMemberInfo();

  const isPrivateOrSupplierMember = isMemberSupplierUser || isSharedOnlyMember;

  const getIdCurrentMember = () => {
    if (isPrivateOrSupplierMember && !memberInfo) return userInfo?.member?.id;
    return memberInfo?.id;
  };

  const qaSpecDataHeader = null;

  const checkAssignProductToSupplier = () => {
    const idMember = getIdCurrentMember();

    const isCurrentMemberAssignedToQaSpec =
      qaSpecDataHeader?.assignTo === idMember;

    const allowSubmitBtnStatus = ['open', 'rejected'];

    const isOpenOrRejected = allowSubmitBtnStatus.includes(
      qaSpecDataHeader?.status?.toLowerCase()
    );

    return isCurrentMemberAssignedToQaSpec && isOpenOrRejected;
  };

  return {
    checkAssignProductToSupplier,
  };
};

export default useCheckAssignProductToSupplier;
